export default __webpack_public_path__ + "static/media/st_michaels.png";